export const SET_FORM_TEMPLATES_LIST = "SET_FORM_TEMPLATES_LIST";
export const SET_LOADING = "SET_LOADING";
export const SET_FORM_TYPE = "SET_FORM_TYPE";
export const SET_TEMPLATES = "SET_TEMPLATES";
export const SET_ERROR = "SET_ERROR";
export const SET_FORMS_TEMPLATES = "SET_FORMS_TEMPLATES";
export const SET_FORM_STATE = "SET_FORM_STATE";
export const SET_FORM_STATE_ERRORS = "SET_FORM_STATE_ERRORS";
export const SET_ALERT = "SET_ALERT";
export const SET_FORM_INFO = "SET_FORM_INFO";
export const SET_FORM_SIGNATORIES = "SET_FORM_SIGNATORIES";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_AGENT_DETAILS = "SET_AGENT_DETAILS";
export const SET_ALL_AGENT_NAMES = "SET_ALL_AGENT_NAMES";
export const SET_PARTIES_FIELDS = "SET_PARTIES_FIELDS";
export const SET_SUPPORTING_DOCS = "SET_SUPPORTING_DOCS";
export const SET_SHARED_FORMS = "SET_SHARED_FORMS";
export const RESET_FORM_STATE = "RESET_FORM_STATE";
